<template>
  <div>
    <h1 class="indigo--text">Clientes</h1>
    <v-text-field
      v-model="searchString"
      solo
      label="Buscar Clientes"
      prepend-inner-icon="mdi-magnify"
      background-color="grey lighten-3"
    ></v-text-field>
    <div v-if="users.length > 0">
      <ClientCard v-for="(user, index) in search" :user="user" :key="index" @updateUsers="getUsers"></ClientCard>
    </div>
    <div v-else>
      <p>Aún no hay clientes en la plataforma</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ClientCard from "@/components/ClientCard";
export default {
  components: {
    ClientCard
  },
  data() {
    return {
      users: [],
      searchString: "",
      host: process.env.VUE_APP_HOST
    };
  },
  methods: {
    getUsers() {
      axios
        .get(this.host + "/users/read.php?query=*")
        .then(response => {
		  this.users = response.data.users;


        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    search() {
      return this.users.filter(user => {
        let find = false;

        Object.keys(user).forEach(element => {
          let elString = user[element] + "";

          if (
            elString.toLowerCase().includes(this.searchString.toLowerCase())
          ) {
            find = true;
          }
        });

        return find;
      });
    }
  }
};
</script>